import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Typography } from '@material-ui/core';

import { APPROVAL_TYPE } from 'src/data/brandTerm';
import TextLink from 'src/components/TextLink';
import { ButtonText } from 'src/components/ButtonText';
import { BusinessBookDemoButton } from 'src/components/BusinessBookDemoButton';
import { DetectedBrandTerm } from '../DetectedBrandTerm';
import { useStyles } from './useStyles';

const DEMO_BRAND_TERM = {
  id: 1,
  term: 'Artificial Intelligence',
  approvalType: APPROVAL_TYPE.doNotUse,
  description: '',
  tags: [],
  replaceWith: 'Artificial Intelligence',
  enabled: false,
  lastModifyingUser: {
    name: '',
  },
  updatedAt: new Date().toISOString(),
};

export const DetectedBrandTermDemo = ({
  className,
  onApplyClick,
  onEditClick,
  onBusinessBookDemoClick,
}) => {
  const styles = useStyles();

  const [demoOpen, setDemoOpen] = useState(false);

  return (
    <div className={cx(styles.root, className)}>
      {!demoOpen ? (
        <div>
          <Typography className={styles.labelEmpty}>
            Manage your company’s tone in one hub by setting allowed and disallowed terms.
          </Typography>
          <TextLink
            component="button"
            className={styles.viewMore}
            onClick={() => setDemoOpen(true)}
          >
            View more details
          </TextLink>
        </div>
      ) : (
        <div className={styles.demoWrapper}>
          <Typography className={styles.demoBadge}>Business Plan feature</Typography>
          <Typography className={styles.demoTitle}>Define your brand term rules</Typography>
          <Typography className={styles.demoDescription}>
            Manage your company’s tone in one hub by setting allowed and disallowed terms.
          </Typography>
          <DetectedBrandTerm
            className={styles.demoBrandTerm}
            brandTerm={DEMO_BRAND_TERM}
            termInText={'AI'}
            onApplyClick={onApplyClick}
            onEditClick={onEditClick}
            disabled
          />
          <div className={styles.demoActions}>
            <ButtonText
              className={styles.button}
              onClick={() => setDemoOpen(false)}
              color="primary"
              variant="text"
            >
              Collapse
            </ButtonText>
            <BusinessBookDemoButton
              className={styles.button}
              onClick={onBusinessBookDemoClick}
              vertical
            />
          </div>
        </div>
      )}
    </div>
  );
};

DetectedBrandTermDemo.propTypes = {
  className: PropTypes.string,
  onApplyClick: PropTypes.func.isRequired,
  onEditClick: PropTypes.func.isRequired,
  onBusinessBookDemoClick: PropTypes.func.isRequired,
};

DetectedBrandTermDemo.defaultProps = {
  className: '',
  disabled: false,
};
